if (!customElements.get('control-v2-png-gallery')) {
  customElements.define('control-v2-png-gallery', class extends HTMLElement {
    static requests = new Map();
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.images = [...this.querySelectorAll('img[data-png-srcset]')];
      this.observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting && !this.hidden) this.load(entry.target);
      }), { rootMargin: '250px' });
      this.images.forEach(img => this.observer.observe(img));
      this.visibilityObserver = new MutationObserver(() => this.loadNearby());
      this.visibilityObserver.observe(this, { attributes: true, attributeFilter: ['hidden'] });
      this.onResize = () => { clearTimeout(this.timer); this.timer = setTimeout(() => this.loadNearby(), 150); };
      window.addEventListener('resize', this.onResize);
      this.loadNearby();
    }
    disconnectedCallback() {
      this.observer?.disconnect(); this.visibilityObserver?.disconnect();
      window.removeEventListener('resize', this.onResize); clearTimeout(this.timer); this.initialized = false;
    }
    loadNearby() {
      if (this.hidden) return;
      this.images.forEach(img => {
        const rect = img.getBoundingClientRect();
        if (rect.bottom >= -250 && rect.top <= innerHeight + 250) this.load(img);
      });
    }
    async selectedWidth(img) {
      // Match the actual responsive slot and screen density before the PNG fetch.
      const slot = Math.max(1, Math.ceil(img.getBoundingClientRect().width));
      img.sizes = slot + 'px';
      const target = slot * (window.devicePixelRatio || 1);
      return [600, 1200, 2400].find(width => width >= target) || 2400;
    }
    async load(img) {
      try {
        const width = await this.selectedWidth(img);
        if (this.hidden || ![600, 1200, 2400].includes(width) || Number(img.dataset.pngRequested) === width) return;
        img.dataset.pngRequested = width;
        const url = img.getAttribute('data-png-' + width), requests = this.constructor.requests;
        if (!requests.has(url)) {
          requests.set(url, fetch(url, { headers: { Accept: 'image/png' } }).then(async response => {
            if (!response.ok || !response.headers.get('Content-Type')?.includes('image/png')) throw new Error('PNG image unavailable');
            return URL.createObjectURL(await response.blob());
          }).catch(error => { requests.delete(url); throw error; }));
        }
        const objectUrl = await requests.get(url);
        if (Number(img.dataset.pngRequested) !== width) return;
        img.pngSources ??= new Map(); img.pngSources.set(width, objectUrl);
        img.srcset = [...img.pngSources].map(([w, blob]) => blob + ' ' + w + 'w').join(', ');
        img.src = objectUrl;
        await img.decode();
        img.dataset.pngLoaded = String(img.naturalWidth); delete img.dataset.pngError;
      } catch (error) { delete img.dataset.pngRequested; img.dataset.pngError = error.message; }
    }
  });
}

